<template>
  <section class="sn-h4">
    <p v-if="$vuetify.breakpoint.mdAndDown">
      {{ labelText }}
    </p>
    <v-text-field
      ref="textfield"
      v-model="inputText"
      outlined
      single-line
      class="action-text-field"
      :color="$vuetify.breakpoint.lgAndUp ? '#F7F7F7' : '#BFBFBF'"
      :height="height"
      :label="$vuetify.breakpoint.lgAndUp ? labelText : ''"
      :rules="rules"
      :type="type"
      :validate-on-blur="validateOnBlur"
      @keyup.enter="handleInput"
    >
      <template
        v-if="$vuetify.breakpoint.lgAndUp"
        v-slot:append
      >
        <v-btn
          class="action-text-field-appended-btn"
          dark
          x-large
          :height="height"
          @click="handleInput"
        >
          {{ buttonText }}
        </v-btn>
      </template>
    </v-text-field>
    <v-btn
      v-if="$vuetify.breakpoint.mdAndDown"
      class="action-text-field-mobile-btn"
      block
      dark
      x-large
      :height="height"
      @click="handleInput"
    >
      {{ buttonText }}
    </v-btn>
  </section>
</template>

<script>
export default {
  props: {
    labelText: {
      type: String,
      required: false,
      default: 'Type in me!'
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    buttonText: {
      type: String,
      required: false,
      default: 'Click me!'
    },
    height: {
      type: Number,
      required: false,
      default: 64
    },
    type: {
      type: String,
      required: false,
      default: 'text'
    },
    validateOnBlur: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      inputText: ''
    }
  },
  methods: {
    handleInput () {
      const tf = this.$refs.textfield
      tf.blur()
      tf.validate()
      if (tf.valid) {
        return this.$emit('action-btn-clicked', this.inputText)
      }
    }
  }
}
</script>

<style lang="scss">
  @import '~/assets/css/snui';

  .action-text-field fieldset {
    background-color: $sn-white;
    border-width: 1px;
  }

  .action-text-field.v-input--has-state fieldset {
    border-width: 1px;
  }

  .action-text-field.v-input--is-focused fieldset {
    color: $sn-primary-03;
    border-width: 1px;
  }

  .action-text-field input:focus {
    caret-color: $sn-primary-03;
  }

  .action-text-field-appended-btn, .action-text-field-mobile-btn {
    text-transform: none;
    font-weight: 600;
    letter-spacing: 0;
  }
  .action-text-field-appended-btn {
    margin-right: -12px;
    margin-top: -17px;
    border-radius: 0 4px 4px 0;
  }
  .action-text-field-mobile-btn {
    border-radius: 4px;
  }

  .action-text-field .v-label {
    color: $sn-gray-04;
    margin-top: 4px;
  }

  .action-text-field.v-input--is-focused .v-label {
    display: none;
  }

  @media screen and (min-width: $medium-screen-size + 1) {
    .action-text-field {
      max-width: 560px;
    }
    .v-text-field--outlined fieldset {
      border-color: transparent;
    }
    .action-text-field .v-input__slot {
      box-shadow: $sn-shadow-depth-2;
    }
  }
</style>
